<template lang="pug">
  div
    Section1Widget(to="/")
    b-spinner(v-if="busy" variant="secondary")
    b-card.text-left(v-for="post in posts" :key="post.id" :title="post.name")
      b-card-text {{post.text}}
      b-card-img(:src="assets_base_url + post.image_1" v-if="post.image_1")
</template>
<script>
import Section1Widget from './components/Section1Widget.vue'
// import {ApiError} from './common/Api'
import ApiHandlingMixin from './common/ApiHandlingMixin'

export default {
  name: 'Events',
  mixins: [ApiHandlingMixin],
  components: {
    Section1Widget,
  },
  data: function(){
    return {
      assets_base_url: process.env.VUE_APP_ASSETS_URL,
      posts: [],
    }
  },
  computed: {},
  created: async function(){
    await this.loadPosts();
  },
  methods: {
    loadPosts: async function(){
    try{
      this.in_process ++;
      this.resetMessageState();
      let postsResp = await this.$mobileapi.getPosts();
      postsResp.posts.forEach(p=>{
        if(this.$root.lang.startsWith('en')){
          p.name = p.name_en;
          p.text = p.text_en;
        } else {
          p.name = p.name_zh;
          p.text = p.text_zh;
        }
      });
      this.posts = postsResp.posts;
    }catch(ex){
      console.error(ex);
      this.message = ex.message;
    } finally {
      this.in_process--;
    }
    }
  }
}
</script>
